import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bar-chart-3",
  "use": "bar-chart-3-usage",
  "viewBox": "0 0 22 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 20\" id=\"bar-chart-3\">\n  <g stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n    <path d=\"M9 1h4v18H9zM17 6h4v13h-4zM1 11h4v8H1z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol